import * as queryString from 'query-string';
import { PlanEnum, PlanLabelEnum, BillingIntervalEnum } from 'enums';
import { europeanCountries } from 'utils/countries';
import plans from './plans.json';
import locales from './locales.json';
import { getEnv } from 'utils';

export function resolvePlan(plan) {
  return [PlanEnum.STUDENT, PlanEnum.RESEARCHER, PlanEnum.LAB_RESEARCHER].includes(plan)
    ? plan
    : PlanEnum.RESEARCHER;
}

export function resolveBillingInterval(billingInterval, plan) {
  if (billingInterval === BillingIntervalEnum.SEMESTER && plan !== PlanEnum.RESEARCHER) {
    return BillingIntervalEnum.YEAR;
  }

  return Object.values(BillingIntervalEnum).includes(billingInterval)
    ? billingInterval
    : BillingIntervalEnum.YEAR;
}

export function getPlanData(plan, billingInterval, countryCode, teamSize = 0) {
  switch (plan) {
    case PlanEnum.STUDENT:
      if (billingInterval === BillingIntervalEnum.YEAR) {
        if (countryCode === 'CN') {
          return {
            label: PlanLabelEnum[plan],
            currency: 'CNY',
            monthlyPrice: 24.91,
            totalPrice: 299.0,
            discount: 549.42,
            discountPercent: 45.6,
            totalUsd: 84,
          };
        }

        if (countryCode === 'JP') {
          return {
            label: PlanLabelEnum[plan],
            currency: 'JPY',
            monthlyPrice: 980,
            totalPrice: 11760,
            discount: 11760,
            discountPercent: 50,
            totalUsd: 84,
          };
        }

        return {
          label: PlanLabelEnum[plan],
          currency: 'US$',
          monthlyPrice: 7,
          totalPrice: 84,
          discount: 84,
          discountPercent: 50,
          totalUsd: 84,
        };
      }

      if (billingInterval === BillingIntervalEnum.QUARTER) {
        if (countryCode === 'CN') {
          return {
            label: PlanLabelEnum[plan],
            currency: 'CNY',
            monthlyPrice: 29.33,
            totalPrice: 88.0,
            discount: 284.7,
            discountPercent: 69.1,
            totalUsd: 36,
          };
        }
      }

      if (countryCode === 'CN') {
        return {
          label: PlanLabelEnum[plan],
          currency: 'CNY',
          monthlyPrice: 38.0,
          totalPrice: 38.0,
          discount: null,
          discountPercent: null,
          totalUsd: 14,
        };
      }

      if (countryCode === 'JP') {
        return {
          label: PlanLabelEnum[plan],
          currency: 'JPY',
          monthlyPrice: 1960,
          totalPrice: 1960,
          discount: null,
          discountPercent: null,
          totalUsd: 14,
        };
      }

      return {
        label: PlanLabelEnum[plan],
        currency: 'US$',
        monthlyPrice: 14,
        totalPrice: 14,
        discount: null,
        discountPercent: null,
        totalUsd: 14,
      };
    case PlanEnum.RESEARCHER:
      if (billingInterval === BillingIntervalEnum.YEAR) {
        if (countryCode === 'CN') {
          return {
            label: PlanLabelEnum[plan],
            currency: 'CNY',
            monthlyPrice: 58.25,
            totalPrice: 699.0,
            discount: 976.15,
            discountPercent: 28.4,
            totalUsd: 144,
          };
        }

        if (countryCode === 'JP') {
          return {
            label: PlanLabelEnum[plan],
            currency: 'JPY',
            monthlyPrice: 1658,
            totalPrice: 19900,
            discount: 22100,
            discountPercent: 53,
            totalUsd: 144,
          };
        }

        return {
          label: PlanLabelEnum[plan],
          currency: 'US$',
          monthlyPrice: 12,
          totalPrice: 144,
          discount: 84,
          discountPercent: 37,
          totalUsd: 144,
        };
      }

      if (billingInterval === BillingIntervalEnum.SEMESTER) {
        return {
          label: PlanLabelEnum[plan],
          currency: 'US$',
          monthlyPrice: 10.83,
          totalPrice: 65,
          discount: 25,
          discountPercent: 28,
          totalUsd: 65,
        };
      }

      if (billingInterval === BillingIntervalEnum.QUARTER) {
        if (countryCode === 'CN') {
          return {
            label: PlanLabelEnum[plan],
            currency: 'CNY',
            monthlyPrice: 63,
            totalPrice: 189,
            discount: 386.0,
            discountPercent: 51,
            totalUsd: 36,
          };
        }

        return {
          label: PlanLabelEnum[plan],
          currency: 'US$',
          monthlyPrice: 12,
          totalPrice: 36,
          discount: 21,
          discountPercent: 37,
          totalUsd: 36,
        };
      }

      if (countryCode === 'CN') {
        return {
          label: PlanLabelEnum[plan],
          currency: 'CNY',
          monthlyPrice: 68.0,
          totalPrice: 68.0,
          discount: null,
          discountPercent: null,
          totalUsd: 19,
        };
      }

      if (countryCode === 'JP') {
        return {
          label: PlanLabelEnum[plan],
          currency: 'JPY',
          monthlyPrice: 3500,
          totalPrice: 3500,
          discount: null,
          discountPercent: null,
          totalUsd: 19,
        };
      }

      return {
        label: PlanLabelEnum[plan],
        currency: 'US$',
        monthlyPrice: 19,
        totalPrice: 19,
        discount: null,
        discountPercent: null,
        totalUsd: 19,
      };
    case PlanEnum.LAB_RESEARCHER:
      if (billingInterval === BillingIntervalEnum.YEAR) {
        if (countryCode === 'CN') {
          return {
            label: PlanLabelEnum[plan],
            currency: 'CNY',
            monthlyPrice: 249.91,
            totalPrice: 2999.0,
            discount: 5287.46,
            discountPercent: 43.2,
            totalUsd: 780,
          };
        }

        if (countryCode === 'JP') {
          return {
            label: PlanLabelEnum[plan],
            currency: 'JPY',
            monthlyPrice: 8333,
            totalPrice: 99999,
            discount: 65601,
            discountPercent: 40,
            totalUsd: 780,
          };
        }

        return {
          label: PlanLabelEnum[plan],
          currency: 'US$',
          monthlyPrice: 65,
          totalPrice: 780,
          discount: 408,
          discountPercent: 34,
          totalUsd: 780,
        };
      }

      if (countryCode === 'CN') {
        return {
          label: PlanLabelEnum[plan],
          currency: 'CNY',
          monthlyPrice: 399.0,
          totalPrice: 399.0,
          discount: null,
          discountPercent: null,
          totalUsd: 99,
        };
      }

      if (countryCode === 'JP') {
        return {
          label: PlanLabelEnum[plan],
          currency: 'JPY',
          monthlyPrice: 13800,
          totalPrice: 13800,
          discount: null,
          discountPercent: null,
          totalUsd: 99,
        };
      }

      return {
        label: PlanLabelEnum[plan],
        currency: 'US$',
        monthlyPrice: 99,
        totalPrice: 99,
        discount: null,
        discountPercent: null,
        totalUsd: 99,
      };
    default:
      throw new Error(`Failed to get plan data. Unknown plan [${plan}]`);
  }
}

/**
 * @typedef {'S'|'R'|'L'} PlanID - The plan ID
 *
 * @typedef {'US'|'BR'|'IN'|'EU'|'JP'|'CN'} LocaleCode - The locale code
 *
 * @typedef {import('../enums').BillingIntervalID} BillingIntervalID
 *
 * @typedef {Object} PlanCycle
 * @property {number} billedPrice - The actual price to be billed for the cycle
 *
 * @typedef {Record<BillingIntervalID, PlanCycle>} PlanCycles
 *
 * @typedef {Object} PlanLocale
 * @property {PlanID} id - The plan ID
 * @property {PlanCycles} cycles - The different prices for the plan, depending on the billing interval
 *
 * @typedef {Object} Plan
 * @property {PlanID} id - The plan ID
 * @property {string} name - The plan name
 * @property {Record<LocaleCode, PlanLocale>} locales - The different prices for the plan, depending on the locale
 *
 * @typedef {Object} LocaleCurrency
 * @property {string} id - The currency ID
 * @property {string} langTag - The language tag
 * @property {string} label - The currency label
 *
 * @typedef {Object} LocalePromotion
 * @property {string} code - The promotion code
 * @property {number} discountPercentage - The discount percentage
 *
 * @typedef {Object} Locale
 * @property {LocaleCurrency} currency - The currency object for the locale
 * @property {LocalePromotion} [promotion] - The promotion object for the locale, if any
 */

/**
 * Formats a price by locale, including currency symbol and decimal separator
 * @param {number} price - The price to format
 * @param {LocaleCode} localeCode - The locale code
 * @returns {string} The formatted price, e.g. `US$100.00`
 */
export function formatPriceByLocale(price, localeCode) {
  if (typeof price !== 'number') {
    return price;
  }

  const hasDecimal = price % 1 !== 0;
  const locale = locales[localeCode];
  const { currency } = locale;

  const formatter = new Intl.NumberFormat(currency.langTag, {
    style: 'currency',
    currency: currency.id,
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: 2,
  });

  const formattedPrice = formatter.format(price);

  // We display US$ for USD currency, as it is not restricted to the US
  if (currency.id === locales.US.currency.id) {
    return formattedPrice.replace('$', 'US$');
  }

  return formattedPrice;
}

/**
 * @typedef SavingsResult
 * @property {number} [savings] - The amount saved by choosing the longer billing interval
 * @property {number} [savingsPercentage] - The percentual savings of the longer cycle annual cost
 * @property {string} [savingsPercentageDisplay] - The savings percentage formatted as a string with '%' symbol
 */

/**
 * Calculates how much the user will save by choosing a longer billing interval
 * @param {number} longerCycleAnnualCost - The annual cost of the longer billing interval
 * @param {number} shorterCycleAnnualCost - The annual cost of the shorter billing interval
 * @returns {SavingsResult} An object containing the savings and the savings percentage
 */
function getSavings(longerCycleAnnualCost, shorterCycleAnnualCost) {
  const savings = longerCycleAnnualCost - shorterCycleAnnualCost;
  const savingsPercentage = (savings / longerCycleAnnualCost) * 100;
  const savingsPercentageDisplay = `${Math.floor(savingsPercentage)}%`;

  return { savings, savingsPercentage, savingsPercentageDisplay };
}

/**
 * Returns locale code for the given country code. Can be `EU`, `US` or the country code.
 * @param {string} countryCode - The user's country code
 * @returns {LocaleCode} The locale code, either `EU` or the country code
 */
function getLocaleCode(countryCode) {
  const countryCodeUpper = countryCode.toUpperCase();

  const availableLocales = Object.keys(locales);
  const isEuropeanCountry = europeanCountries.includes(countryCodeUpper);
  const isSupportedCountry = availableLocales.includes(countryCodeUpper);

  if (isEuropeanCountry) {
    return 'EU';
  }

  if (!isSupportedCountry) {
    return 'US';
  }

  return countryCodeUpper;
}

/**
 * @typedef LocaleData
 * @property {LocaleCode} id - The locale code
 * @property {PlanCycles} cycles - An object containing the price per month of the yearly and monthly cycles
 */

/**
 * Returns the locale for the given plan and locale code
 * @param {Plan} planPricing - The plan pricing data
 * @param {string} localeCode - The country code, or `EU` for European countries
 * @returns {LocaleData} The locale data.
 */
function getLocale(planPricing, localeCode) {
  const hasLocale = !!planPricing.locales[localeCode];

  if (!hasLocale) {
    return planPricing.locales.US;
  }

  return planPricing.locales[localeCode];
}

/**
 * Converts a price to USD based on fixed currency conversion rates
 * @param {number} price - The price to convert
 * @param {string} currency - The currency of the price, can be 'EUR', 'BRL', 'INR'
 * @returns {number} The price in USD
 */
function getTotalInUSD(price, currency) {
  const currencyUpper = currency.toUpperCase();

  if (currencyUpper === 'EUR') {
    return price * 1.08;
  }

  if (currencyUpper === 'BRL') {
    return price * 5.6;
  }

  if (currencyUpper === 'INR') {
    return price * 0.012;
  }

  return price;
}

/**
 * @typedef PlanBasicDataPlanData
 * @property {PlanID} id - The plan ID
 * @property {string} label - The plan label
 * @property {LocaleCode} locale - The locale code
 * @property {string} promotion - The promotion code
 * @property {LocaleCurrency} currency - The currency object for the locale
 *
 * @typedef PlanBasicData
 * @property {LocaleData} localeData - Data related to the locale
 * @property {PlanBasicDataPlanData} planData - Data related to the plan
 */

/**
 * Returns the basic data for a plan, including the locale data and the plan data.
 *
 * @param {PlanID} plan - The plan ID
 * @param {LocaleCode} localeCode - The locale code
 * @returns {PlanBasicData} An object containing the plan data and the locale data
 */
function getPlanBasicData(plan, localeCode) {
  const planPricing = plans[plan];

  const localeData = getLocale(planPricing, localeCode);

  return {
    localeData,
    planData: {
      id: planPricing.id,
      label: planPricing.name,
      locale: localeCode,
      promotion: locales[localeCode].promotion?.code,
      currency: locales[localeCode].currency,
    },
  };
}

/**
 * @typedef {Object} ApplyDiscountParams
 * @property {boolean} floor - Whether to round down the price
 */

/**
 * Applies a discount to a price
 *
 * @param {number} price - The price to apply the discount to
 * @param {number} discountPercentage - The discount percentage
 * @param {ApplyDiscountParams} [params] - The parameters to apply the discount
 * @returns {number} The price with the discount applied
 */
function applyDiscount(originalPrice, discountPercentage, { floor } = { floor: false }) {
  if (floor) {
    return Math.floor(originalPrice * (1 - discountPercentage / 100));
  }
  return originalPrice * (1 - discountPercentage / 100);
}

/**
 * @typedef {Object} ApplyTeamSizeParams
 * @property {boolean} floor - Whether to round down the price
 */

/**
 * Multiplies a price by a team size
 *
 * @param {number} price - The price to apply the team size to
 * @param {*} teamSize - The team size
 * @param {ApplyTeamSizeParams} [params] - The parameters to apply the team size
 * @returns {number} The price with the team size applied
 */
function applyTeamSize(price, teamSize, { floor } = { floor: false }) {
  if (floor) {
    return Math.floor(price * teamSize);
  }
  return price * teamSize;
}

/**
 * @typedef {Object} Prices
 * @property {number} [promotionalBilledPrice] - The actual price to be billed with the promotion applied
 * @property {number} [promotionalPricePerMonth] - The price per month with the promotion applied
 * @property {number} [promotionalPricePerYear] - The price per year with the promotion applied
 * @property {number} billedPrice - The actual price to be billed for the cycle
 * @property {number} pricePerMonth - The price per month for the plan
 * @property {number} pricePerYear - The price per year for the plan
 */

/**
 * Calculates the price, price per month, and price per year for a given plan, billing interval, and team size.
 *
 * @param {number} billedPrice - The billed price for the plan
 * @param {BillingIntervalID} billingInterval - The billing interval (e.g., 'year' or 'month')
 * @param {number} cycleDurationInMonths - The duration of the billing cycle in months
 * @param {number} teamSize - The size of the team
 * @param {LocaleCode} locale - The locale code
 * @returns {Prices} An object containing the calculated prices
 */
function calculatePrices(billedPrice, billingInterval, teamSize, locale) {
  const isYearlyPlan = billingInterval === BillingIntervalEnum.YEAR;
  const pricePerYear = isYearlyPlan ? billedPrice : billedPrice * 12;
  const pricePerMonth = isYearlyPlan ? pricePerYear / 12 : billedPrice;

  let promotionalPrices = {};

  if (locales[locale].promotion) {
    promotionalPrices = {
      promotionalBilledPrice: applyDiscount(
        applyTeamSize(billedPrice, teamSize),
        locales[locale].promotion.discountPercentage,
      ),
      promotionalPricePerMonth: applyDiscount(
        applyTeamSize(pricePerMonth, teamSize),
        locales[locale].promotion.discountPercentage,
      ),
      promotionalPricePerYear: applyDiscount(
        applyTeamSize(pricePerYear, teamSize),
        locales[locale].promotion.discountPercentage,
      ),
    };
  }

  return {
    billedPrice: applyTeamSize(billedPrice, teamSize),
    pricePerMonth: applyTeamSize(pricePerMonth, teamSize),
    pricePerYear: applyTeamSize(pricePerYear, teamSize),
    ...promotionalPrices,
  };
}

/**
 * Calculates the savings percentage and savings amount for a given monthly annual cost and price per year.
 *
 * @param {number} annualCost - The annual cost for the plan with the yearly billing interval
 * @param {number} pricePerYear - The price per year for the plan with the given billing interval
 * @returns {SavingsResult} An object containing the savings percentage and savings amount
 */
function calculateSavings(annualCost, pricePerYear) {
  const savingsData = getSavings(annualCost, pricePerYear);
  return savingsData;
}

/**
 * @typedef FormattedPrices
 * @property {string} [promotionalPricePerMonthDisplay] - The promotional price per month display
 * @property {string} [promotionalPricePerYearDisplay] - The promotional price per year display
 * @property {string} billedPriceDisplay - The billed price display
 * @property {string} pricePerMonthDisplay - The price per month display
 * @property {string} pricePerYearDisplay - The price per year display
 */

/**
 * Formats the prices for a given locale code, to render them in the UI.
 *
 * @param {Prices} prices - An object containing the prices
 * @param {LocaleCode} localeCode - The locale code
 * @returns {FormattedPrices} An object containing the formatted prices
 */
function formatPrices(prices, localeCode) {
  return {
    promotionalPricePerMonthDisplay:
      prices.promotionalPricePerMonth &&
      formatPriceByLocale(prices.promotionalPricePerMonth, localeCode),
    promotionalPricePerYearDisplay:
      prices.promotionalPricePerYear &&
      formatPriceByLocale(prices.promotionalPricePerYear, localeCode),
    billedPriceDisplay: formatPriceByLocale(prices.billedPrice, localeCode),
    pricePerMonthDisplay: formatPriceByLocale(prices.pricePerMonth, localeCode),
    pricePerYearDisplay: formatPriceByLocale(prices.pricePerYear, localeCode),
  };
}

/**
 * @typedef { PlanBasicDataPlanData & SavingsResult & Prices & FormattedPrices & {
 *  priceInUSD: number,
 *  savingsDisplay: string,
 * } } PlanPricingData
 *
 */

/**
 * Provides the pricing data for a given plan, billing interval, country code and optional team size
 * @param {PlanID} plan - The plan ID, as in PlanEnum (e.g. S, R, L)
 * @param {BillingIntervalID} billingInterval - The billing interval ID, as in BillingIntervalEnum (e.g. "year", "month")
 * @param {string} countryCode - The country code of the user
 * @param {number} teamSize - The size of the team, if applicable, defaults to 1
 * @returns {PlanPricingData} The pricing data
 */
export function getPlanPricingData(plan, billingInterval, countryCode = 'US', teamSize = 1) {
  if (!plans[plan]) {
    throw new Error(`Failed to get plan pricing data. Unknown plan [${plan}]`);
  }

  if (!countryCode) {
    throw new Error(`Failed to get plan pricing data. Invalid countryCode [${countryCode}]`);
  }

  const localeCode = getLocaleCode(countryCode);
  const { localeData, planData } = getPlanBasicData(plan, localeCode);

  const prices = calculatePrices(
    localeData.cycles[billingInterval].billedPrice,
    billingInterval,
    teamSize,
    localeCode,
  );

  const monthlyCostPerYear =
    applyTeamSize(localeData.cycles[BillingIntervalEnum.MONTH].billedPrice, teamSize) * 12;
  const isYearly = billingInterval === BillingIntervalEnum.YEAR;
  const savingsData = isYearly ? calculateSavings(monthlyCostPerYear, prices.pricePerYear) : {};

  return {
    ...planData,
    ...savingsData,
    ...prices,
    ...formatPrices(prices, localeCode),
    priceInUSD: getTotalInUSD(prices.billedPrice, locales[localeCode].currency.id),
    savingsDisplay: formatPriceByLocale(savingsData.savings, localeCode),
  };
}

/**
 * @typedef {Record<BillingIntervalID, PlanPricingData>} PlansDataByBillingIntervals
 */

/**
 * Generates pricing data for a specific plan and country across different billing intervals.
 * @param {PlanID} planId - The identifier of the plan (e.g., 'R', 'L').
 * @param {string} countryCode - The country code in uppercase (e.g., 'US', 'BR').
 * @param {BillingIntervalID[]} billingIntervals - An array of billing interval identifiers (e.g., ['year', 'month']).
 * @param {number} teamSize - The size of the team, relevant for team plans.
 * @returns {PlansDataByBillingIntervals} An object where keys are billing intervals and values are pricing data for each interval.
 */
function getPlansDataByBillingIntervals(planId, countryCode, billingIntervals, teamSize) {
  return billingIntervals.reduce((cyclesData, currentBillingInterval) => {
    const planData = getPlanPricingData(planId, currentBillingInterval, countryCode, teamSize);
    cyclesData[currentBillingInterval] = { ...planData };
    return cyclesData;
  }, {});
}

/**
 * @typedef {Object} CountryData
 * @property {LocaleCode} locale - The locale code
 * @property {string} [promotion] - The promotion code
 * @property {LocaleCurrency} currency - The currency object for the locale
 * @property {PlansDataByBillingIntervals} cycles - The pricing data for each billing interval
 *
 * @typedef {Record<LocaleCode, CountryData>} PlansDataByCountry
 */

/**
 * Generates pricing data for a specific plan across multiple countries.
 * @param {PlanID} planId - The identifier of the plan (e.g., 'R', 'L').
 * @param {LocaleCode[]} countriesCodes - An array of country codes (e.g., ['US', 'BR', 'IN']).
 * @param {BillingIntervalID[]} billingIntervals - An array of billing interval identifiers (e.g., ['year', 'month']).
 * @param {number} teamSize - The size of the team, relevant for team plans.
 * @returns {PlansDataByCountry} An object where keys are country codes and values are country-specific pricing data including cycles.
 */
function getPlansDataByCountry(planId, countriesCodes, billingIntervals, teamSize) {
  return countriesCodes.reduce((countryData, currentCountryCode) => {
    const localeCode = getLocaleCode(currentCountryCode);
    const cyclesData = getPlansDataByBillingIntervals(
      planId,
      localeCode,
      billingIntervals,
      teamSize,
    );
    countryData[localeCode] = {
      locale: localeCode,
      promotion: locales[localeCode].promotion?.code,
      currency: locales[localeCode].currency,
      cycles: cyclesData,
    };

    return countryData;
  }, {});
}

/**
 * @typedef {Object} PlansPricingDataParams
 * @property {PlanID[]} [plansIds] - The plans IDs
 * @property {string[]} [countriesCodes] - The country codes
 * @property {BillingIntervalID[]} [billingIntervals] - The billing interval IDs
 * @property {number} [teamSize] - The size of the team, if applicable
 *
 * @typedef {Object} PlansPricingData
 * @property {PlanID} id - The plan ID
 * @property {string} label - The plan label
 * @property {PlansDataByCountry} locales - The pricing data per locale
 */

/**
 * Returns pricing data for multiple plans, countries, and billing intervals.
 *
 * @param {PlansPricingDataParams} [params] - Parameters to filter plans data
 * locales and billing intervals, ignoring `teamSize`
 * @returns {Record<PlanID, PlansPricingData>} Data for the requested plans
 */
export function getPlansPricingData({
  plansIds = ['R', 'L'],
  countriesCodes = ['US'],
  billingIntervals = ['year', 'month'],
  teamSize = 1,
} = {}) {
  const plansData = plansIds.reduce((plansData, currentPlanId) => {
    const planDataByCountry = getPlansDataByCountry(
      currentPlanId,
      countriesCodes,
      billingIntervals,
      currentPlanId === PlanEnum.LAB_RESEARCHER ? teamSize : 1,
    );
    plansData[currentPlanId] = {
      id: currentPlanId,
      label: plans[currentPlanId].name,
      locales: planDataByCountry,
    };

    return plansData;
  }, {});

  return plansData;
}

/**
 * Returns locale data for the given country code
 * @param {string} countryCode - The user's country code
 * @returns {Locale & { id: LocaleCode }} localeData
 */
export function getLocaleData(countryCode) {
  const localeCode = getLocaleCode(countryCode || 'US');
  return {
    id: localeCode,
    ...locales[localeCode],
  };
}

/**
 * Checks if the coupon is available for the user's country
 * If the coupon is not in the list of localized coupons, it is considered global and valid for any country.
 * If the coupon is in the list of localized coupons, it is only valid if the user's country code matches the coupon's locale code.
 *
 * @param {string} couponCode - The coupon code to check. This can be a global or localized coupon code.
 * @param {string} countryCode - The user's country code
 * @returns {boolean} Returns true if the coupon is valid for the user's country, false otherwise.
 */
export function checkLocaleCouponForUserCountry(couponCode, countryCode) {
  const localizedCoupons = [
    { localeCode: 'BR', couponCode: 'brl_discount' },
    { localeCode: 'IN', couponCode: 'inr_discount' },
  ];

  const localeCode = getLocaleCode(countryCode);

  const isLocaleCoupon = localizedCoupons.find((locCoupon) => couponCode === locCoupon.couponCode);

  if (!isLocaleCoupon) return true;

  if (isLocaleCoupon.localeCode === localeCode) return true;

  return false;
}

const RESEARCHER_LIFE_API_URL = `${getEnv('R_LIFE_SUBSCRIPTION_API_URL')}/get-pack-details`;

function formatAllAccessBenefits(data) {
  if (!data?.benefits) return {};
  return data.benefits.reduce(
    (accBenefits, benefit) => ({
      ...accBenefits,
      [benefit.product_name.replaceAll(' ', '_')]: benefit,
    }),
    {},
  );
}

/**
 * Returns the prices for the Editage All Access bundle
 */
export async function getEditageAllAccessPrices(userCountry) {
  const response = await fetch(
    `${RESEARCHER_LIFE_API_URL}?${queryString.stringify({
      currency: userCountry.toLowerCase(),
      user_country: userCountry,
      product: 'r-life',
      pack_type: 'all-access-ai-tools',
      pack_machine_name:
        'all-access-tools-monthly,all-access-tools-quarterly,all-access-tools-annual',
    })}`,
  );

  const result = await response.json();

  const formattedData = {
    annual: {
      ...result.data['all-access-tools-annual'],
      benefits: formatAllAccessBenefits(result.data['all-access-tools-annual']),
    },
    quarterly: {
      ...result.data['all-access-tools-quarterly'],
      benefits: formatAllAccessBenefits(result.data['all-access-tools-quarterly']),
    },
    monthly: {
      ...result.data['all-access-tools-monthly'],
      benefits: formatAllAccessBenefits(result.data['all-access-tools-monthly']),
    },
  };

  return formattedData;
}

/**
 * Returns the prices for MTG From Editage Central
 */
export async function getMtgPricesFromEditage(userCountry) {
  const response = await fetch(
    `${RESEARCHER_LIFE_API_URL}?${queryString.stringify({
      currency: userCountry.toLowerCase(),
      user_country: userCountry,
      product: 'mtg',
      pack_type: 'mind-the-graph',
      pack_machine_name: 'mtg-researcher-monthly,mtg-researcher-annual',
    })}`,
  );

  const result = await response.json();

  const formattedData = {
    annual: {
      ...result.data['mtg-researcher-annual'],
      benefits: formatAllAccessBenefits(result.data['mtg-researcher-annual']),
      pack_machine_name: 'mtg-researcher-annual',
    },
    monthly: {
      ...result.data['mtg-researcher-monthly'],
      benefits: formatAllAccessBenefits(result.data['mtg-researcher-monthly']),
      pack_machine_name: 'mtg-researcher-monthly',
    },
  };

  return formattedData;
}

/**
 * Returns the prices for MTG Student Packs From Editage Central
 */
export async function getMtgStudentPricesFromEditage(userCountry) {
  const response = await fetch(
    `${RESEARCHER_LIFE_API_URL}?${queryString.stringify({
      currency: userCountry.toLowerCase(),
      user_country: userCountry,
      product: 'mtg',
      pack_type: 'mind-the-graph-students',
      pack_machine_name: 'mtg-student-monthly,mtg-student-quarterly,mtg-student-annual',
    })}`,
  );

  const result = await response.json();

  const formattedData = {
    annual: {
      ...result.data['mtg-student-annual'],
      benefits: formatAllAccessBenefits(result.data['mtg-student-annual']),
      pack_machine_name: 'mtg-student-annual',
    },
    quarterly: {
      ...result.data['mtg-student-quarterly'],
      benefits: formatAllAccessBenefits(result.data['mtg-student-quarterly']),
      pack_machine_name: 'mtg-student-quarterly',
    },
    monthly: {
      ...result.data['mtg-student-monthly'],
      benefits: formatAllAccessBenefits(result.data['mtg-student-monthly']),
      pack_machine_name: 'mtg-student-monthly',
    },
  };

  return formattedData;
}

const ALL_ACCESS_CURRENCY_EXCHANGE_RATE = [
  {
    id: 'JPY',
    symbol: '¥',
    inUSD: 138,
  },
  {
    id: 'CNY',
    symbol: '￥',
    inUSD: 7.1,
  },
  {
    id: 'GBP',
    symbol: '£',
    inUSD: 0.9,
  },
  {
    id: 'EUR',
    symbol: '€',
    inUSD: 0.98,
  },
  {
    id: 'INR',
    symbol: '₹',
    inUSD: 85,
  },
  {
    id: 'KRW',
    symbol: '￦',
    inUSD: 1300,
  },
  {
    id: 'KRW',
    symbol: '₩',
    inUSD: 1300,
  },
];

/**
 * Some prices from the API are returned in USD, and need to be converted
 * to the user's currency. Not the same thing as the user country in this case,
 * as R.Life API works with different currencies than us. BRL users use EUR for example.
 */
export function convertAllAccessPriceToCurrency(price, symbol, userCountry) {
  if (symbol === '$') {
    return {
      price: Math.round(price),
      symbol,
    };
  }

  // This solves the problem of JPY and CNY having the same symbol
  if (userCountry.toUpperCase() === 'JP') {
    const currency = ALL_ACCESS_CURRENCY_EXCHANGE_RATE.find((currency) => currency.id === 'JPY');

    return {
      price: Math.round(price * currency.inUSD),
      symbol: currency.symbol,
    };
  }

  const currency = ALL_ACCESS_CURRENCY_EXCHANGE_RATE.find((currency) => currency.symbol === symbol);

  return {
    price: Math.round(price * currency.inUSD),
    symbol: currency.symbol,
  };
}

/**
 * Returns the prices for the MTG Publisher Semi Annual plan
 */
export async function getMtgPublisherSemiAnnualPrices(userCountry) {
  const response = await fetch(
    `${RESEARCHER_LIFE_API_URL}?${queryString.stringify({
      currency: userCountry.toLowerCase(),
      user_country: userCountry,
      product: 'mtg',
      pack_type: 'mind-the-graph-publisher',
      pack_machine_name: 'mtg-publisher-semi-annual',
    })}`,
  );

  const result = await response.json();

  const packData = result.data?.['mtg-publisher-semi-annual'];

  if (!packData) {
    console.error('mtg-publisher-semi-annual pack data not found in API response');
    return null;
  }

  const formattedData = {
    semiAnnual: {
      ...packData,
      benefits: packData.benefits ? formatAllAccessBenefits(packData) : {},
      pack_machine_name: 'mtg-publisher-semi-annual',
    },
  };

  return formattedData;
}

/**
 * Returns the prices for the Mtg Prime bundle
 */
export async function getMtgPrimePrices(userCountry) {
  const response = await fetch(
    `${RESEARCHER_LIFE_API_URL}?${queryString.stringify({
      currency: userCountry.toLowerCase(),
      user_country: userCountry,
      product: 'mtg',
      pack_type: 'pp-prime-v2',
      pack_machine_name: 'paperpal-prime-v2,paperpal-prime-monthly-v2',
    })}`,
  );

  const result = await response.json();

  const formattedData = {
    annual: {
      ...result.data['paperpal-prime-v2'],
      benefits: formatAllAccessBenefits(result.data['paperpal-prime-v2']),
    },
    monthly: {
      ...result.data['paperpal-prime-monthly-v2'],
      benefits: formatAllAccessBenefits(result.data['paperpal-prime-monthly-v2']),
    },
  };

  return formattedData;
}
